/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('oauth.signin', {
      url: '/signin?code&app&username&password&continue&type&state&client_id&message&utm_source&utm_campaign&utm_medium&original_source&parameter_url&gcl_id&referrer&first_visit&post_login_page&collect_coupon&from_domain',
      template: '<sign-in></sign-in>',
      data: { pageTitle: 'Sign In - Your one account for Shopping & Shipping • ShoppRe™️' },
    });
}



// WEBPACK FOOTER //
// ./client/app/oauth/sign-in/sign-in.routes.js